import { Item } from '@lendi-ui/dropdown';

export enum GuarantorRelationshipType {
  FATHER = 'Father',
  MOTHER = 'Mother',
  SPOUSE = 'Spouse',
  BROTHER = 'Brother',
  SISTER = 'Sister',
  SON = 'Son',
  DAUGHTER = 'Daughter',
  OTHER_RELATIVE = 'Other Relative',
  OTHER = 'Other',
}

export const RELATIONSHIP_TYPE_OPTIONS = Object.entries(GuarantorRelationshipType).map(
  ([key, value]: [string, string]) => ({
    label: value,
    value,
  })
) as Item[];

export const INDUSTRY_TOOLTIP = `
Industry (nature of business) for Trust applications will most commonly be 'Financial Asset Investing' or 'Residential Property Operators'`;
